<div id="content" class="allcp-form" ng-controller="InvoiceAnalyticController">
    <div ng-include="'modules/company/menus/report_menu.html'"></div>
    <div class="row mt20">
        <div class="col-md-12 mb20">
            <div class="panel date-range">
                <div class="panel-body" >

                    <div class="row mt-2">
                        <div class="col-md-4">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="m-4">
                                    <h3 class="mbn mtn text-dark">{{ data.count.total?data.count.total:0 | currency }} </h3>
                                    <strong>Total</strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="m-4">
                                    <h3 class="mbn mtn text-dark">{{ data.count.paid?data.count.paid:0 | currency }} </h3>
                                    <strong>Paid</strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="m-4">
                                    <h3 class="mbn mtn text-dark">{{ data.count.open?data.count.open:0 | currency }} </h3>
                                    <strong>Open</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-4">
                        <div class="col-md-6">
                            <canvas id="doughnut" class="chart chart-doughnut" ng-if="chartData"
                                    chart-data="chartData" chart-labels="series" chart-colours="chartColors"
                                    chart-legend="true">
                            </canvas>
                        </div>
                        <div class="col-md-6">
                            <canvas id="bar" class="chart chart-bar" chart-data="barChartData"
                                    chart-labels="data.chart.labels" chart-series="series"
                                    chart-colours="chartColors" chart-legend="true">
                            </canvas>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-12">
                            <div class="progress">
                                <div 
                                    class="progress-bar progress-bar-success progress-bar-striped" 
                                    role="progressbar" 
                                    aria-valuenow="{{ (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) }}"
                                    aria-valuemin="0" 
                                    aria-valuemax="100" 
                                    ng-style="{ width: (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) + '%'}">
                                    {{ (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) }}% Başarı Oranı
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr> -->
                    <hr>
                    <div class="table-responsive" ng-if="data.orders.data.length == 0">
                        <div class="alert alert-default pastel">
                            <i class="fa fa-info pr10"></i>
                            <strong>
                                Order Not Found
                            </strong>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
